(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './notifications.duck', './NotificationContainer', './Notification', './PermanentNotification', './levels', './getGuid'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./notifications.duck'), require('./NotificationContainer'), require('./Notification'), require('./PermanentNotification'), require('./levels'), require('./getGuid'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.notifications, global.NotificationContainer, global.Notification, global.PermanentNotification, global.levels, global.getGuid);
    global.index = mod.exports;
  }
})(this, function (exports, _notifications, _NotificationContainer, _Notification, _PermanentNotification, _levels, _getGuid) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getGuid = exports.levels = exports.NotificationContainer = exports.dismissNotification = exports.notifyWarn = exports.notifySuccess = exports.notifyInfo = exports.notifyError = exports.PermanentNotification = exports.Notification = exports.notificationsReducer = undefined;

  var _NotificationContainer2 = _interopRequireDefault(_NotificationContainer);

  var _Notification2 = _interopRequireDefault(_Notification);

  var _PermanentNotification2 = _interopRequireDefault(_PermanentNotification);

  var _levels2 = _interopRequireDefault(_levels);

  var _getGuid2 = _interopRequireDefault(_getGuid);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.notificationsReducer = _notifications.reducer;
  exports.Notification = _Notification2.default;
  exports.PermanentNotification = _PermanentNotification2.default;
  exports.notifyError = _notifications.notifyError;
  exports.notifyInfo = _notifications.notifyInfo;
  exports.notifySuccess = _notifications.notifySuccess;
  exports.notifyWarn = _notifications.notifyWarn;
  exports.dismissNotification = _notifications.dismissNotification;
  exports.NotificationContainer = _NotificationContainer2.default;
  exports.levels = _levels2.default;
  exports.getGuid = _getGuid2.default;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Notifications/index.js
// module id = 521
// module chunks = 1